import { render, staticRenderFns } from "./movementStockTable.vue?vue&type=template&id=d57f336c&scoped=true"
import script from "./movementStockTable.vue?vue&type=script&lang=js"
export * from "./movementStockTable.vue?vue&type=script&lang=js"
import style0 from "./movementStockTable.vue?vue&type=style&index=0&id=d57f336c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57f336c",
  null
  
)

export default component.exports